import {CallEntity} from "./call-entity";

export interface CallControlMessage {

    id: string;

    installation_id: string;

    callee: CallEntity;

    kind: CallControlKind;

}

// export type CallControlKind = "start" | "cancel" | "reject" | "timeout" | "forward";

export enum CallControlKind {
    Start = "start",
    Cancel = "cancel",
    Reject = "reject",
    Timeout = "timeout",
    Forward = "forward",
    Close = "close",
}
